import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, Grid, Avatar, Stack, Rating } from '@mui/material';
import { servicesColors as colors } from '../theme';
const testimonials = [
    {
        quote: 'We were losing good HVAC techs to competitors because we took too long to call them back. StanorAI cut our screening from 2 days to 30 minutes.',
        author: 'Robert M.',
        role: 'Owner',
        industry: 'HVAC Company',
        avatar: 'R',
        rating: 5,
        highlight: '2 days → 30 min',
    },
    {
        quote: 'Finding ASE-certified mechanics used to be a nightmare. Now I upload resumes and instantly see who has the right certs. It\'s a no-brainer.',
        author: 'Jennifer S.',
        role: 'Service Manager',
        industry: 'Auto Repair Chain',
        avatar: 'J',
        rating: 5,
        highlight: 'ASE detection',
    },
    {
        quote: 'Peak season was killing us. 200+ landscaping applications, 3 people screening. StanorAI let us hire our whole summer crew in one week.',
        author: 'Carlos D.',
        role: 'Operations Director',
        industry: 'Landscaping Co.',
        avatar: 'C',
        rating: 5,
        highlight: '200 apps / week',
    },
];
export const TestimonialsSection = () => {
    return (_jsx(Box, { component: "section", sx: {
            py: { xs: 8, md: 10 },
            backgroundColor: colors.bgLight,
        }, children: _jsxs(Container, { maxWidth: "lg", children: [_jsxs(Box, { sx: { textAlign: 'center', mb: 6 }, children: [_jsx(Typography, { variant: "h2", sx: {
                                fontWeight: 700,
                                color: colors.text,
                                fontSize: { xs: '1.75rem', md: '2.25rem' },
                                mb: 2
                            }, children: "Service Pros Love Us" }), _jsx(Typography, { sx: { color: colors.textSecondary, fontSize: '1.05rem' }, children: "Real results from HVAC, auto, landscaping, and more" })] }), _jsx(Grid, { container: true, spacing: 3, children: testimonials.map((t, index) => (_jsx(Grid, { size: { xs: 12, md: 4 }, children: _jsxs(Box, { sx: {
                                p: 4,
                                height: '100%',
                                backgroundColor: colors.cardBg,
                                borderRadius: 4,
                                border: `1px solid ${colors.border}`,
                                position: 'relative',
                                overflow: 'hidden',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    transform: 'translateY(-6px)',
                                    boxShadow: '0 20px 50px rgba(30, 64, 175, 0.12)',
                                },
                            }, children: [_jsx(Box, { sx: {
                                        position: 'absolute',
                                        top: 16,
                                        right: 16,
                                        backgroundColor: colors.accent,
                                        color: '#ffffff',
                                        px: 1.5,
                                        py: 0.5,
                                        borderRadius: 2,
                                        fontSize: '0.75rem',
                                        fontWeight: 700,
                                    }, children: t.highlight }), _jsx(Rating, { value: t.rating, readOnly: true, size: "small", sx: { mb: 2 } }), _jsxs(Typography, { sx: {
                                        color: colors.text,
                                        fontSize: '0.95rem',
                                        lineHeight: 1.7,
                                        mb: 3,
                                        minHeight: { md: 120 },
                                    }, children: ["\u201C", t.quote, "\u201D"] }), _jsxs(Stack, { direction: "row", spacing: 2, alignItems: "center", children: [_jsx(Avatar, { sx: {
                                                bgcolor: colors.primary,
                                                width: 48,
                                                height: 48,
                                                fontWeight: 700,
                                            }, children: t.avatar }), _jsxs(Box, { children: [_jsx(Typography, { sx: { fontWeight: 600, color: colors.text, fontSize: '0.95rem' }, children: t.author }), _jsxs(Typography, { sx: { color: colors.textMuted, fontSize: '0.8rem' }, children: [t.role, " \u2022 ", t.industry] })] })] })] }) }, index))) })] }) }));
};
